export const arrayOfRoutes = [
    /** Static points */
    { name: 'homePage', path: '/' },
    { name: 'blogsPage', path: '/blog' },
    { name: 'cartPage', path: '/cart' },
    { name: 'checkoutPage', path: '/checkout' },
    { name: 'orderPage', path: '/order/access' },
    { name: 'voucherPage', path: '/order/voucher' },
    { name: 'wishList', path: '/wishlist' },
    { name: 'storiesPage', path: '/traveler-stories' },
    { name: 'partnersPage', path: '/partners' },
    { name: 'previewActivityPage', path: '/preview/activity' },
    { name: 'reviewAddPage', path: '/review/add' },
    { name: 'authPage', path: '/auth' },
    { name: 'destinationsPage', path: '/destination' },

    /** Itinerary pages */
    { name: 'itineraryPage', path: '/itinerary/:slug([a-z0-9-]+)' },

    /** Partners pages */
    { name: 'partnerPage', path: '/partners/:slug([a-z0-9-]+)/:id([0-9]+)' },
    { name: 'partnersDestinationPage', path: '/partners/:slug([a-z0-9-]+)' },

    /** Activity pages */
    { name: 'activityPage', path: '/:slug([a-z0-9-]+)/details/:id([0-9]+)' },
    { name: 'activityReviewsPage', path: '/:slug([a-z0-9-]+)/details/:id([0-9]+)/reviews' },

    /** Search pages */
    {
        name: 'attractionsPage',
        path: '/attractions/:destination([a-z0-9-]+)/:category([a-z0-9-]+)?',
    },

    /** Blogs pages */
    { name: 'blogPostPage', path: '/blog/:slug([a-z0-9-]+)' },
    { name: 'blogsDestinationPage', path: '/blog/:state([a-z]+)/:slug([a-z0-9-]+)' },

    /** Destination pages */
    { name: 'destinationPage', path: '/destination/:state([a-z]+)/:slug([a-z0-9-]+)' },

    /** Stories pages */
    { name: 'storiesDestinationPage', path: '/traveler-stories/:state([a-z]+)/:slug([a-z0-9-]+)' },
    { name: 'storyPage', path: '/traveler-stories/:slug([a-z0-9-]+)' },

    /** Content pages */
    { name: 'contentPage', path: '/:slug([a-z0-9-#]+)' },
];

const routes = arrayOfRoutes.reduce((acc, route) => {
    acc[route.name] = route.path;
    return acc;
}, {});

export default routes;
